import { useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Text,
  useColorModeValue,
  Input,
  Tag,
  TagLabel,
  TagCloseButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  ModalFooter,
  Select,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useHookFormMask } from "use-mask-input";
// Custom components
import Map from "./components/Map";
import Card from "components/card/Card";
import CitysTable from "views/admin/clients/components/CitysTable";
import { FaFilter } from "react-icons/fa";

// Assets
import ClientsTable from "./components/ClientesTable";
import { useMap } from "hooks/MapHook";
import { useQuery } from "react-query";

type FilterProps = {
  [key: string]: string | number | any;
};

export default function MapContainer() {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [filters, setFilters] = useState<FilterProps>({} as FilterProps);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const { register, handleSubmit, setValue: formSetValue } = useForm();
  const registerWithMask = useHookFormMask(register);
  const { findCityFilter } = useMap();
  const { data, isLoading } = useQuery(["findCityFilter"], () =>
    findCityFilter()
  );

  const handleRemoveFIlter = (filterKey: string) => {
    delete filters[filterKey];
    formSetValue(filterKey, "");
    setFilters({ ...filters });
  };

  const submitFilterUsers = (data: FilterProps) => {
    setFilters(data);
    onClose();
  };

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
        mb="20px"
        gap={{ base: "20px", xl: "20px" }}
        display={{ base: "block", xl: "grid" }}
      >
        <Flex
          flexDirection="column"
          gridArea={{ xl: "1 / 1 / 5 / 5", "2xl": "1 / 1 / 5 / 5" }}
        >
          <Map
            cidade={filters.cityFilter}
            documento={filters.documentFilter}
            nome={filters.nameFilter}
          />
        </Flex>
      </Grid>

      <Grid templateColumns="1fr" gap={4} w="100%">
        <Flex direction="column">
          <Flex
            mt="45px"
            mb="20px"
            justifyContent="space-between"
            direction={{ base: "column", md: "row" }}
            align={{ base: "start", md: "center" }}
          >
            <Text color={textColor} fontSize="2xl" ms="24px" fontWeight="700">
              Clientes
            </Text>
            <Flex
              align="center"
              me="20px"
              ms={{ base: "24px", md: "0px" }}
              mt={{ base: "20px", md: "0px" }}
            >
              {Object.entries(filters).map(([key, value], index) => {
                if (value === "") {
                  return null;
                }
                return (
                  <Tag p={1.5} mr={2} key={index}>
                    <TagLabel>{String(value)}</TagLabel>
                    <TagCloseButton onClick={() => handleRemoveFIlter(key)} />
                  </Tag>
                );
              })}

              <Button onClick={onOpen}>
                <FaFilter />
              </Button>
            </Flex>
          </Flex>
          <Card px="0px" mb="20px">
            <ClientsTable
              cidade={filters.cityFilter}
              documento={filters.documentFilter}
              nome={filters.nameFilter}
            />
          </Card>
        </Flex>

        <Flex
          flexDirection="column"
          gridArea={{ xl: "1 / 3 / 2 / 4", "2xl": "1 / 2 / 3 / 4" }}
          mt="45px"
          maxW={{ base: "100vw" }}
        >
          <Text
            color={textColor}
            fontSize="2xl"
            ms="24px"
            mb="24px"
            fontWeight="700"
          >
            Cidades
          </Text>
          <Card px="0px" mb="20px">
            <CitysTable />
          </Card>
        </Flex>
      </Grid>

      {/* Modal do filtro */}

      <Modal isOpen={isOpen} onClose={onClose}>
        <form onSubmit={handleSubmit(submitFilterUsers)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Filtros de pesquisa</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Nome</FormLabel>
                <Input
                  color={textColor}
                  {...register("nameFilter")}
                  type="text"
                />
                <FormLabel>Documento</FormLabel>
                <Input
                  color={textColor}
                  {...registerWithMask("documentFilter", [
                    "999.999.999-99",
                    "99.999.999/9999-99",
                  ])}
                />
                <FormLabel>Cidade</FormLabel>

                <Select {...register("cityFilter")}>
                  <option value=""></option>
                  {!isLoading &&
                    data.map((cidade) => {
                      return (
                        <option
                          style={{
                            color: textColor,
                          }}
                          value={cidade.CIDADE}
                          key={cidade.CIDADE}
                        >
                          {cidade.CIDADE}
                        </option>
                      );
                    })}
                </Select>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit" colorScheme="teal">
                Aplicar
              </Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </Box>
  );
}
